<template>
  <v-dialog v-model="dialog" max-width="900">
    <tabla-detalles-de-pagos :pagos="adjuntos" class="popup-pagos">
    </tabla-detalles-de-pagos>
  </v-dialog>
</template>

<script>

import TablaDetallesDePagos from './TablaDetallesDePagos'

export default {
  components: {
    TablaDetallesDePagos
  },

  props: {
    adjuntos: Array
  },

  data () {
    return {
      dialog: false
    }
  },

  methods: {
    showDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    }
  }

}
</script>

<style>
.popup-pagos {
  background-color: white;
  border-radius: 5px;
  padding: 10px;
}
</style>
